export default [
  {
    path:'/admin/activity/activity_list',
    name: 'ActivityList',
    component: () => import('@/views/activity/activity_list'),
    meta:{
      title:'活动-列表',
      keepAlive:false
    }
  },
  {
    path:'/admin/activity/activity_classify',
    name: 'ActivityClassify',
    component: () => import('@/views/activity/activity_classify'),
    meta:{
      title:'活动-分类',
      keepAlive:false
    }
  },
  {
    path:'/admin/activity/activity_order',
    name: 'ActivityOrder',
    component: () => import('@/views/activity/activity_order'),
    meta:{
      title:'活动-订单',
      keepAlive:false
    }
  },
  {
    path:'/admin/activity/activity_set',
    name: 'ActivitySet',
    component: () => import('@/views/activity/activity_set'),
    meta:{
      title:'活动-设置',
      keepAlive:false
    }
  },
  {
    path:'/admin/activity/edit_activity',
    name: 'EditActivity',
    component: () => import('@/views/activity/edit_activity'),
    meta:{
      title:'活动新增/编辑',
      keepAlive:false
    }
  },
  {
    path:'/admin/activity/add_ticket',
    name: 'ActivityAddTicket',
    component: () => import('@/views/activity/add_ticket'),
    meta:{
      title:'票种设置',
      keepAlive:false
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/activity.js